/*eslint-disable */
import LayerService from '@/services/layers/LayerService';
import store from '@/store/index';

import {
  LayerGroup, LeafletEvent, Marker,
} from 'leaflet';
import { IModalData } from '@/services/layers/IModalData';

export default class ParkingGroupsLayerService extends LayerService {
  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    const lastUpdate: string = !!metaData.last_status && !!metaData.last_status.dateTime
                       ? metaData.last_status.dateTime as string
                       : this.noData;

    const title: string = `${metaData.name} (${metaData.parking_id})`

    const modalData: IModalData = {
      title: title,
      content: '',
      navigationPoint: leafletMarker,
      lastUpdate: lastUpdate,
      icon: this.markerIcon,
      templateName: 'TemplateModalParking',
      metaData: metaData,
    };

    // store.commit('displayModal', modalData); //-- disable showing modal information
  };

  redrawLayer = (): LayerGroup<any> => {
    const { selectedParkingCode } = store.state;
    const { parkingGroups } = store.state;

    // added additional array wrapping to ensure correct geometry type
    const wrappedFeatures = parkingGroups.features.map((item: any) => {
      return{
        ...item,
        geometry: {
          type: "MultiLineString",
          coordinates: [item.geometry.coordinates]
        }
      }
    });

    const specificGroups = {
      type:"FeatureCollection",
      features: wrappedFeatures.filter((group: any) => group.properties.parking_id === selectedParkingCode),
    };

    return this.generateParkingPolyLinesLayer(specificGroups);
  };
}
